import styled from 'styled-components';

export const MessageWaitWrapper = styled.div`



// #message-wait span{
//   display: inline-block;
//   width: 5px;
//   height: 5px;
//   border-radius: 100%;
//   background-color:rgb(10, 10, 10);
//   margin: 5px 2px;
//   opacity: 0;
// }

// #message-wait span:nth-child(1){
//   animation: opacitychange 1s ease-in-out infinite;
// }

// #message-wait span:nth-child(2){
//   animation: opacitychange 1s ease-in-out 0.33s infinite;
// }

// #message-wait span:nth-child(3){
//   animation: opacitychange 1s ease-in-out 0.66s infinite;
// }

// @keyframes opacitychange{
//   0%, 100%{
//     opacity: 0;
//   }

//   60%{
//     opacity: 1;
//   }
// }



#message-wait span{
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background-color:rgb(0, 0, 0);
  margin: 5px 2px;
}

#message-wait span:nth-child(1){
  animation: bounce 1s ease-in-out infinite;
}

#message-wait span:nth-child(2){
  animation: bounce 1s ease-in-out 0.33s infinite;
}

#message-wait span:nth-child(3){
  animation: bounce 1s ease-in-out 0.66s infinite;
}

@keyframes bounce{
  0%, 75%, 100%{
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }

  25%{
    -webkit-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}
`;
